package one.healthium.data.health_log

import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext
import kotlinx.serialization.json.Json
import one.healthium.base.coroutines.IO
import one.healthium.domain.health_log.HealthLogRepository
import one.healthium.domain.health_log.models.HealthLogQuestionModel
import one.primehealth.app.BaseAppResourceProvider

class AppHealthLogRepository(
    private val json: Json,
    private val appResourceProvider: BaseAppResourceProvider,
) : HealthLogRepository {

    override suspend fun getHealthLogQuestions(): List<HealthLogQuestionModel> {
        return withContext(Dispatchers.IO) {
            val bytes = appResourceProvider.readBytes("files/symptoms/symptoms.json")
            json.decodeFromString<HealthLogDataDto>(bytes.decodeToString()).questions
        }
    }
}